import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconFilterGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.08301 4.08203V5.42878L7.89988 9.24565L7.89996 9.24573C8.15345 9.49918 8.29589 9.84294 8.29597 10.2014V10.2016V12.3547L9.20338 11.4473V10.2016V10.2014C9.20345 9.84294 9.3459 9.49918 9.59939 9.24573L9.59947 9.24565L13.4163 5.42878V4.08203H4.08301ZM2.97896 2.97798C3.23248 2.72446 3.57633 2.58203 3.93486 2.58203H13.5645C13.923 2.58203 14.2669 2.72446 14.5204 2.97798C14.7739 3.2315 14.9163 3.57535 14.9163 3.93388V5.49027V5.49043C14.9163 5.8489 14.7738 6.19266 14.5203 6.44611L14.5202 6.44619L10.7034 10.2631V11.758C10.7034 11.9569 10.6244 12.1476 10.4837 12.2883L8.0763 14.6957C7.8618 14.9102 7.53921 14.9744 7.25896 14.8583C6.9787 14.7422 6.79597 14.4687 6.79597 14.1654V10.2631L2.9791 6.44619L2.97902 6.44611C2.72553 6.19266 2.58308 5.8489 2.58301 5.49043V5.49027V3.93388C2.58301 3.57535 2.72543 3.2315 2.97896 2.97798ZM14.1663 10.9154C14.5806 10.9154 14.9163 11.2512 14.9163 11.6654V13.4154H16.6663C17.0806 13.4154 17.4163 13.7512 17.4163 14.1654C17.4163 14.5796 17.0806 14.9154 16.6663 14.9154H14.9163V16.6654C14.9163 17.0796 14.5806 17.4154 14.1663 17.4154C13.7521 17.4154 13.4163 17.0796 13.4163 16.6654V14.9154H11.6663C11.2521 14.9154 10.9163 14.5796 10.9163 14.1654C10.9163 13.7512 11.2521 13.4154 11.6663 13.4154H13.4163V11.6654C13.4163 11.2512 13.7521 10.9154 14.1663 10.9154Z"
        fill={fillColor}
      />
    </g>
  );
};

export const IconFilterSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...(props.svg ?? {})}
    >
      <IconFilterGroup {...props} />
    </svg>
  );
};
